import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './styles/Landing.css';

export default function Landing() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) navigate('/app', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <div className="landing">
      <header className="landing-header">
        <div
          className="landing-brand"
          onClick={() => navigate('/')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && navigate('/')}
        >
          <div className="landing-mark">M</div>
          <div className="landing-name">
            <div className="landing-title">MuDates</div>
            <div className="landing-subtitle">Meet. Match. Message.</div>
          </div>
        </div>

        <div className="landing-actions">
          <button className="btn ghost" onClick={() => navigate('/login')}>Log in</button>
          <button className="btn primary" onClick={() => navigate('/signup')}>Get started</button>
        </div>
      </header>

      <main className="landing-main">
        <section className="hero">
          <div className="hero-copy">
            <h1>
              Find your person.
              <span className="accent"> Faster</span>.
            </h1>

            <p>
              A modern dating experience—discover matches, chat instantly, and upgrade when you’re ready.
            </p>

            {/* ✅ Trusted by row */}
            <div className="trusted-row" aria-label="Trusted by">
              <div className="trusted-pill">
                <span className="trusted-dot" />
                Trusted by <strong>10k+</strong> users
              </div>
              <div className="trusted-pill">
                <span className="trusted-dot" />
                <strong>120+</strong> daily matches
              </div>
              <div className="trusted-pill">
                <span className="trusted-dot" />
                <strong>4.8★</strong> average rating
              </div>
            </div>

            <div className="hero-cta">
              <button className="btn primary" onClick={() => navigate('/signup')}>Create account</button>
              <button className="btn outline" onClick={() => navigate('/subscriptions')}>Upgrade now</button>
            </div>

            <div className="hero-trust">
              <div className="chip">✅ Verified profiles</div>
              <div className="chip">🔒 Privacy controls</div>
              <div className="chip">⚡ Fast messaging</div>
            </div>
          </div>

          {/* ✅ Animated gradient border wrapper */}
          <div className="hero-card-wrap" aria-hidden="true">
            <div className="hero-card">
              <div className="card-top">
                <div className="pulse-dot" />
                <div className="card-title">Today’s picks</div>
              </div>

              <div className="card-grid">
                <div className="profile-skeleton" />
                <div className="profile-skeleton" />
                <div className="profile-skeleton" />
                <div className="profile-skeleton" />
              </div>

              <div className="card-bottom">
                <button className="btn tiny" onClick={() => navigate('/signup')}>Start swiping</button>
                <button className="btn tiny ghost" onClick={() => navigate('/login')}>I have an account</button>
              </div>
            </div>
          </div>
        </section>

        <section className="features">
          <div className="feature">
            <div className="icon">💖</div>
            <h3>Smart matching</h3>
            <p>Find compatible people based on your preferences.</p>
          </div>
          <div className="feature">
            <div className="icon">💬</div>
            <h3>Instant chat</h3>
            <p>Message your matches with a clean, fast UI.</p>
          </div>
          <div className="feature">
            <div className="icon">👀</div>
            <h3>See interest</h3>
            <p>Track likes, visitors, favorites, and events.</p>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <span>© {new Date().getFullYear()} MuDates</span>
        <button className="btn link" onClick={() => navigate('/subscriptions')}>Plans & pricing</button>
      </footer>
    </div>
  );
}